
export const orderInfo = state => state.orderInfo

export const parkinglotId = state => state.parkinglotId

export const openId = state => state.openId

export const buyId = state => state.buyId

export const doorId = state => state.doorId

export const currentPath = state => state.currentPath

export const parkrec = state => state.parkrec

export const parkingInfo = state => state.parkingInfo

export const couponFee = state => state.couponFee

export const lastPlateno = state => state.lastPlateno

export const areaId = state => state.areaId

export const checkedParkingLotId = state => state.checkedParkingLotId

export const userPhone = state => state.userPhone

export const userOpenid = state => state.userOpenid

export const businessIds = state => state.businessIds

export const taskId = state => state.taskId

export const orderSn = state => state.orderSn
export const resultOrderSn = state => state.resultOrderSn

export const receiptOrderSnObj = state => state.receiptOrderSnObj

export const totalPrice = state => state.totalPrice

export const isNotification = state => state.isNotification

export const clickMerRecord = state => state.clickMerRecord

export const interfaceManner = state => state.interfaceManner

export const keyTopInImgUrl = state => state.keyTopInImgUrl

export const isCardPay = state => state.isCardPay

export const keyTopOrderNo = state => state.keyTopOrderNo;

export const parkRecId = state => state.parkRecId;

export const receiptInfo = state => state.receiptInfo

export const orderSnList = state => state.orderSnList

export const receiptParkinglotId = state => state.receiptParkinglotId

export const abParkId = state => state.abParkId

export const abShow = state => state.abShow

export const isOpenAdvertising = state => state.isOpenAdvertising
